import React from "react";
import Footer from "../components/Footer";
import "./LegalPages.css";

const PrivacyPolicy = () => {
  return (
    <>
      <section className="legal-page">
        <div className="legal-page-container">
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Last updated: March 2, 2026</p>

          <h2>Overview</h2>
          <p>
            This Privacy Policy explains how Lattice Labs collects, uses, stores,
            and protects personal data when you visit our website, contact us, or
            engage with our services.
          </p>

          <h2>Information We Collect</h2>
          <ul>
            <li>
              Contact details such as name, email address, phone number, and
              company information submitted through forms.
            </li>
            <li>
              Communication details from emails, meeting requests, and support
              inquiries.
            </li>
            <li>
              Basic technical data such as browser type, device information, and
              site usage analytics.
            </li>
          </ul>

          <h2>How We Use Information</h2>
          <ul>
            <li>To respond to inquiries and provide requested services.</li>
            <li>To improve website performance and user experience.</li>
            <li>
              To communicate project updates, operational notices, and relevant
              service information.
            </li>
            <li>To comply with legal and contractual obligations.</li>
          </ul>

          <h2>Legal Basis</h2>
          <p>
            We process personal data based on one or more of the following:
            consent, contractual necessity, legitimate business interests, or
            compliance with legal obligations.
          </p>

          <h2>Data Sharing</h2>
          <p>
            We do not sell personal data. Data may be shared with trusted service
            providers that support our operations, subject to confidentiality and
            security safeguards, or when required by law.
          </p>

          <h2>Data Retention</h2>
          <p>
            Personal data is retained only for as long as required to fulfill the
            purposes described in this policy, meet contractual requirements, and
            satisfy legal obligations.
          </p>

          <h2>Data Security</h2>
          <p>
            We apply organizational and technical safeguards designed to protect
            personal data against unauthorized access, disclosure, alteration, or
            loss.
          </p>

          <h2>Your Rights</h2>
          <ul>
            <li>Request access to personal data we hold about you.</li>
            <li>Request correction of inaccurate or incomplete data.</li>
            <li>Request deletion or restriction where legally applicable.</li>
            <li>Object to specific processing activities, where permitted.</li>
          </ul>

          <h2>Policy Updates</h2>
          <p>
            We may revise this Privacy Policy to reflect legal, technical, or
            operational changes. The latest version date is always shown at the
            top of this page.
          </p>

          <div className="legal-contact">
            <h2>Contact</h2>
            <p>
              For privacy-related questions, contact us at{" "}
              <a href="mailto:info@latticelabs.com">info@latticelabs.com</a>.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
